// Borrower upload links, staff side (ticket 211, batch 211-4).
import { api } from './api';

export const uploadRequestsApi = {
  // { contact_id } → that contact's links and the files that came back;
  // { mine: true, outstanding: true } → links I sent that still work.
  list: (params) => api.get('/upload-requests', { params }).then(r => r.data.items || []),
  revoke: (requestId) => api.post(`/upload-requests/${requestId}/revoke`).then(r => r.data),
  // → { upload_url, expires_at }. Sends nothing.
  regenerate: (requestId) => api.post(`/upload-requests/${requestId}/regenerate`).then(r => r.data),
  filePath: (requestId, docId) => `/upload-requests/${requestId}/files/${docId}`,
};
